import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { ViewRenderer } from '@unpispas/upp-wdgt';

import { languageService, languageSupport } from '@unpispas/upp-base';
import { stateService } from '@unpispas/upp-base';
import { dataService } from '@unpispas/upp-data';
import { viewService } from '@unpispas/upp-base';

import { Place } from '@unpispas/upp-data';

import { UserView } from '@unpispas/upp-data';
import { PlaceView } from '@unpispas/upp-data';

@Component({
    selector: 'upp-user-start',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-start.html',
    styleUrls: [
      './upp-start.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]       
})
export class UppUserStartComponent extends languageSupport implements OnInit, OnDestroy {

    private _user_subscription: Subscription | null = null;
    private _autoEntered = false;

    constructor(
        private lang: languageService,
        private change: ViewRenderer,
        private data: dataService,
        private state: stateService,
        public view: viewService,
    ){
        super(lang, change.cdref);
    }

    /** Whether the start screen may offer creating a place (POS only). */
    get CanAddPlace(): boolean {
        return this.state.WorkMode !== 'PTF';
    }

    ngOnInit(){
        if (this.user){
            this._user_subscription = this.user.OnViewRefresh.subscribe(
            () => {
                this._TryAutoEnterPlace();
                this.change.markForCheck();
            });
        }

        this._TryAutoEnterPlace();
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._user_subscription){
            this._user_subscription.unsubscribe();
            this._user_subscription = null;
        }
    }

    get user(): UserView | null {
        return this.data.alives.get(this.data.user) as UserView;
    }    

    /********************************/
    /* TEMPLATE HELPERS             */
    /********************************/

    /**
     * Stable identity for place thumbnails in the start grid.
     * @param _index - Row index (unused).
     * @param place - Place view for the row.
     * @returns Stable uuid or null.
     */
    PlaceTrack(_index: number, place: PlaceView): string | null {
        return place?._uuid || null;
    }

    /********************************/
    /* EVENT HANDLERS               */
    /********************************/

    SetPlace(place: PlaceView): void {
        if (place){
            this.data.SetPlace(place.object).then(
            () => {
                this.view.View = 'PLACE';
            });
        }

        this.change.markForCheck();        
    }

    AddPlace(): void {
        if (!this.CanAddPlace){
            return;
        }

        if (this.user){
            const _place = new Place(null, this.data);
            if (_place){
                _place.user = this.user.object;
                _place.status = 'AC';
            }
    
            this.data.SetPlace(_place).then(
            () => {
                this.view.View = 'PLACE';
            });
        }

        this.change.markForCheck();
    }

    /**
     * In Pinpad mode, enter the only place automatically (once per mount).
     */
    private _TryAutoEnterPlace(): void {
        if (this.CanAddPlace || this._autoEntered){
            return;
        }

        const _places = this.user?.places;
        if (!_places || _places.length !== 1){
            return;
        }

        this._autoEntered = true;
        this.SetPlace(_places[0]);
    }
}
